import { getLocalizedMessage, SupportedLanguage } from "@pimo/pimo-l10n";

export function nonNegativeBudgetRule(language?: SupportedLanguage) {
  return {
    value: 0,
    message:
      getLocalizedMessage(
        language ?? "en",
        "validationErrors.nonNegativeBudget"
      ) || "Budget cannot be negative",
  };
}
